export default __webpack_public_path__ + "static/media/go.6608613a.svg";